// removed by extract-text-webpack-plugin
module.exports = {"simple-nav":"main_nav-6xI","simple-nav-content":"main_nav-2Q2","secondary-text-wrapper":"main_nav-3x3"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/SimpleNav/simple_nav.module.scss
// module id = 353
// module chunks = 0